import { LayersIcon, ZapIcon, BookOpenIcon } from 'lucide-react';

export const apparatusList = ['Mat', 'Reformer', 'Cadillac', 'Silla', 'Accesorios', 'Pared', 'Terapéutico'];

export const benefitBadges = [
  {
    icon: BookOpenIcon,
    title: '+280 páginas de contenido',
    text: '+240 ejercicios detallados en 6 tomos organizados por aparato.'
  },
  {
    icon: LayersIcon,
    title: 'Todos los niveles',
    text: 'Inicial, Intermedio, Avanzado — progresión clara para cada alumna.'
  },
  {
    icon: ZapIcon,
    title: 'Listo para usar mañana',
    text: 'Sin preparación extra. Abrí la ficha y da la clase.'
  }
];
